<script setup lang="ts">
import { computed, type HTMLAttributes } from 'vue';
import { TabsList, type TabsListProps } from 'reka-ui';
import { cn } from '@/lib/utils';
const props = defineProps<TabsListProps & { class?: HTMLAttributes['class'] }>();
const forwarded = computed(() => {
  const { class: _class, ...rest } = props;
  return rest;
});
</script>

<template>
  <TabsList
    v-bind="forwarded"
    :class="
      cn(
        'inline-flex h-9 max-w-full items-center justify-center gap-1 overflow-x-auto rounded-md bg-muted p-1 text-muted-foreground',
        props.class
      )
    "
    ><slot
  /></TabsList>
</template>
